import { configureStore } from '@reduxjs/toolkit';
import loginSlice from './features/auth/loginSlice';
import adminLoginSlice from './features/auth/adminLoginSlice';
import toggleSlice from './features/quiz/LogoutSlice';
const store = configureStore({
  reducer: {
    login:loginSlice.reducer,
    adminLogin:adminLoginSlice.reducer,
    toggle:toggleSlice.reducer
  },
});
export default store;